class Manifest {
    name = '';
    url = '';

    constructor() {
        Object.seal(this);
    }
}

export default Manifest;
